<template>
    <v-main class="justify-center" style="height: 100%; width: 100%; position: absolute;">
        <CardNav />
        <v-container>
            <v-row>
                <v-card elevation="12"
                    style="height: calc(100svh - 13.4svh - 2svw - 2svw - 2svw - 2svw - 22.66svh); width: calc(100svw - 2svw - 2svw); margin-top: 2svw; margin-bottom: 2svw; margin-left: 2svw; margin-right: 2svw; border-radius: 9px; display: flex; flex-flow: column">
                    <p
                        style="position: absolute; top: 45%; left: calc(50% - 172px/2 + 5px); font-family: Lato; font-style: normal; color: #3F616C; font-size: 16px; font-weight: 300;">
                        Foto enviada con éxito </p>
                </v-card>
                <v-card elevation="12"
                    style="height: calc(100svh - 13.4svh - 2svw - 2svw - 2svw - 2svw - calc(100svh - 13.4svh - 2svw - 2svw - 2svw - 2svw - 22.66svh)); width: calc(100svw - 2svw - 2svw); margin-left: 2svw; margin-right: 2svw; border-radius: 9px; display: flex; align-items: center; flex-flow: row">
                    <v-btn elevation="12" v-on:click="click(true);"
                        style="margin-left: auto; margin-right: auto; width: 147px; height: 49px; border: 1px solid #E9F6FB;
                          font-family: Lato; text-transform: unset !important; font-style: normal; background-color: #FFFFFF; color: #059BCA; font-size: 16px; box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25); border-radius: 6px;">
                        <b>Ver resultado</b>
                    </v-btn>
                </v-card>
            </v-row>
        </v-container>
    </v-main>
</template>

<script>
import CardNav from './CardNav.vue';
import { nextScreen, nextScreenWithParams, nextScreenWithMoreParams } from '../router/utils.js';
import { preference } from "vue-preferences";

const api = require('../../config/conf.env')

export default {
    name: 'PhotoSent',
    components: {
        CardNav
    },
    data() {
        return {
            heightFirstCard: 0,
            heightSecondCard: 0
        }
    },
    computed: {
        currentHeightFirstCard: {
            get: function () {
                return this.heightFirstCard;
            },
            set: function (newValue) {
                this.heightFirstCard = newValue;
            }
        },
        currentHeightSecondCard: {
            get: function () {
                return this.heightSecondCard;
            },
            set: function (newValue) {
                this.heightSecondCard = newValue;
            }
        },
    },
    methods: {
        matchHeight() {
            if (screen.height <= 700) {
                this.currentHeightFirstCard = 60;
                this.currentHeightSecondCard = 25;
            } else if (screen.height > 701 && screen.height <= 800) {
                this.currentHeightFirstCard = 64;
                this.currentHeightSecondCard = 22;
            } else if (screen.height > 801 && screen.height <= 1400) {
                this.currentHeightFirstCard = 67;
                this.currentHeightSecondCard = 20;
            }
        },
        async click() {
            const status = preference('status', { defaultValue: '' });
            const showResult = preference('showResult', { defaultValue: '' });
            const dialogClass = preference('dialogClass', { defaultValue: '' });
            const properPreparation = preference('properPreparation', { defaultValue: '' });
            if (status.get() == "processed" && showResult.get() == true) {
                if (dialogClass.get() == "correct") {
                    properPreparation.set(true);
                } else {
                    properPreparation.set(false);
                }
                nextScreen(this.$router, '/properpreparation');
            } else if (status.get() == "processed" && showResult.get() == false) {
                nextScreenWithParams(this.$router, 'ProcessCompleted', false);
            } else if (status.get() == "error") {
                nextScreenWithMoreParams(this.$router, 'Error', "Status error", "/lastdeposited");
            }
        }
    },
    mounted() {
        this.matchHeight();
    }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/PhotoSent.vue